import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'

Vue.use(Vuex);

//创建Vuex实例
const store = new Vuex.Store({
  state: {
    siteUrl: 'https://e-test.giant.com.cn',
    loginUrl:'https://e-test.giant.com.cn/#/' ,
    api: {//api链接
      demo: 'http://demo.kssina.com/gmall_mock/api.php?json=',//接口demo
      //common: 'https://project.kssina.com/giant_shop_new/index.php/',//接口
      common: 'https://e-gw-test.giant.com.cn/index.php/',//接口
      admin: 'https://e-gw-test.giant.com.cn/admin.php/',//后台接口，上传图片用
      wechat_share: 'https://wechat.giant.com.cn/Third/Wechat.ashx?action=jspack2',//初始化微信分享
      common_address: 'https://gateway-test.giant.com.cn/giantService',// 收货地址接口
      //login_api: 'https://appapi.giantev.com.cn/restful', //登录接口
      org_api: 'https://org-api-test.giant.com.cn/api', //组织中台接口
    },
    externalurl: {//外部链接
      insure: 'https://insure-test.giant.com.cn',// 保险中台
      opo: 'https://opo-test.giant.com.cn',
      sale_giant: 'https://sale-test.giant.com.cn/index.php',
      order: 'https://e-order-test.giant.com.cn',
      opo_verif: 'https://opo-test.giant.com.cn/pickcode/index.php/New_code/index.html?type=10',//核销
      banner: 'https://opo-test.giant.com.cn/opo/index.php/api/get_app_banner_list',
      chat: 'https://chat-test.giant.com.cn',
      officialwebsite_usercenter: 'https://u-api-test.giant.com.cn/index.php',
      common_sso_jump: 'https://dlinesso-test.giant.com.cn/index.php/api/app_sso_login?token=',//单点登录智能跳转 &url=
      GIANT_CDN: 'https://giant-images.oss-cn-shanghai.aliyuncs.com/eshop-test/static',//捷安特CDN
    },

    DLINE_ENVIRONMENT: '测试环境',//

    Tips503:'当前访问人数较多，请稍后再试',

    loginUser: {},//登录用户信息

    sharetmp:{},
    sharemsg:{},
    shareview:{},

    theme: {
      //headerBgColor: '',
      //headerBgSrc: '',
      //headerBgColor: '#4e66ff',
      //headerBgSrc: 'linear-gradient(104deg, #4e66ff, #2bd5ff)',
    },

    brandList: [],//品牌数组

    globalLimitBuy: 5,//全场单个商品的限购数量

    cartCount: 0,//购物车内商品数量

    browser: (function(ua){
      var a = new Object();
      var b = {
        //micromessenger: /micromessenger/.test(ua),
        msie: /msie/.test(ua) && !/opera/.test(ua),
        opera: /opera/.test(ua),
        safari: /webkit/.test(ua) && !/chrome/.test(ua),
        firefox: /firefox/.test(ua),
        edge: /edge/.test(ua),
        trident: /trident/.test(ua),
        chrome: /chrome/.test(ua)
      };
      var vMark = "";
      for (var i in b) {
        if (b[i]) { vMark = i; break; }//"safari" == i ? "version" : i;
      }
      b.version = vMark && RegExp("(?:" + vMark + ")[\\/: ]([\\d.]+)").test(ua) ? RegExp.$1 : "0";
      b.ie = b.msie;
      b.ie6 = b.msie && parseInt(b.version, 10) == 6;
      b.ie7 = b.msie && parseInt(b.version, 10) == 7;
      b.ie8 = b.msie && parseInt(b.version, 10) == 8;

      //if(vMark == "trident") vMark = "ie11";

      a.b=vMark;
      a.v=b.version;
      a.m=/mobile/i.test(ua); //
      a.wx=/MicroMessenger/i.test(ua);
      a.wxminiprogram=/miniProgram/i.test(ua);
      a.giantapp=/giantapp/i.test(ua);
      a.giantevapp=/giantevapp/i.test(ua);
      a.giantopoapp=/giantopoapp/i.test(ua);
      a.ios=/\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(ua);

      a.huawei=/huawei/i.test(ua);
      a.honor=/honor/i.test(ua);
      a.android = ua.indexOf('Android') > -1 || ua.indexOf('Linux') > -1
      return a;
    })(window.navigator.userAgent.toLowerCase()),

    //电动车专属自定义页面编号
    giantEvIndexId: 27,
    // 经纬度对象
    giant_userpostion:null
  },
  getters: {//相当于计算属性
    themeheaderBgSrc(state){
      if( typeof state.theme == 'object' && state.theme ){
        if( state.theme.headerBgSrc && state.theme.headerBgSrc.indexOf('linear-gradient') != -1 ){
          return state.theme.headerBgSrc;
        } else if(state.theme.headerBgSrc) {
          return 'url('+ state.theme.headerBgSrc +')';
        } else {
          return '';
        }
      } else {
        return '';
      }
    },
  },
  mutations: {//逻辑处理，同步
    updateState( state, data ){//通用修改值
      state[data.label] = data.data;
    },
    changeApi( state, n ){//改变api链接
      if( n ){
        for (const key in n) {
          if (n.hasOwnProperty(key)) {
            state.api[key] = n[key]
          }
        }
      }
    },
    changeExternalurl( state, n ){//改变外部链接
      if( n ){
        for (const key in n) {
          if (n.hasOwnProperty(key)) {
            state.externalurl[key] = n[key]
          }
        }
      }
    },
    changeEnvironment( state, n ){//正式环境撤掉“测试”标志
      state.DLINE_ENVIRONMENT = n;
    },
    changeCartCount( state, n ) {//修改购物车内商品数量
      state.cartCount = n;
    },

    updateTheme( state, n ) {//更新主题皮肤数据
      state.theme = {};
      for( let k in n ){
        state.theme[k] = n[k];//.toString();
      }
    },

    updateBrandList( state, n ) {//更新品牌
      state.brandList = n;
    },

    updateLoginUser( state, data ){//修改登录用户数据
      state.loginUser = data;
    },

    updatesharetmp( state, data ){//
      state.sharetmp = data;
    },
    updatesharemsg( state, data ){//
      state.sharemsg = data;
    },
    updateshareview( state, data ){//
      state.shareview = data;
    },

    updateGlobalLimitBuy( state, data ){//更新限购数量
      state.globalLimitBuy = data;
    },
    updatePosition( state, data ){//更新限购数量
      state.giant_userpostion = data;
    },
  },
  actions: {//类似 mothods，异步
    updateUserPosition({ commit }, { data }) {
      commit('updatePosition', data)
    }
  }
});

//正式环境
if( window.location.host == 'e-yu.giant.com.cn' ){
  store.commit('changeApi', {
    common: 'https://e-gw-yu.giant.com.cn/index.php/',
    admin: 'https://e-gw-yu.giant.com.cn/admin.php/',
    wechat_share: 'https://wechat.giant.com.cn/Third/Wechat.ashx?action=jspack2',
    common_address: 'https://gateway.giant.com.cn/giantService' // 地址维护
  });
  store.commit('changeExternalurl', {
    insure: 'https://insure.giant.com.cn',
    opo: 'https://opo.giant.com.cn',
    sale_giant: 'https://sale.giant.com.cn/index.php',
    order: 'https://e-order-yu.giant.com.cn',
    opo_verif: 'https://opo.giant.com.cn/pickcode/index.php/New_code/index.html?type=10',
    banner: 'https://opo.giant.com.cn/opo/index.php/api/get_app_banner_list',
    chat: 'https://chat.giant.com.cn',
  });
  store.commit('changeEnvironment', '预发环境');//
  store.commit('updateState', {
    label: 'siteUrl',
    data: 'https://e-yu.giant.com.cn',
  });
} else if( window.location.host == 'e.giant.com.cn' ){//正式环境
  store.commit('changeApi', {
    common: 'https://e-gw.giant.com.cn/index.php/',
    admin: 'https://e-gw.giant.com.cn/admin.php/',
    wechat_share: 'https://wechat.giant.com.cn/Third/Wechat.ashx?action=jspack2',
    org_api: 'https://org-api.giant.com.cn/api', //组织中台接口
    common_address: 'https://gateway.giant.com.cn/giantService' // 地址维护
  });
  store.commit('changeExternalurl', {
    insure: 'https://insure.giant.com.cn',
    opo: 'https://opo.giant.com.cn',
    sale_giant: 'https://sale.giant.com.cn/index.php',
    order: 'https://e-order.giant.com.cn',
    opo_verif: 'https://opo.giant.com.cn/pickcode/index.php/New_code/index.html?type=10',
    banner: 'https://opo.giant.com.cn/opo/index.php/api/get_app_banner_list',
    chat: 'https://chat.giant.com.cn',
    officialwebsite_usercenter: 'https://u-api.giant.com.cn/index.php',
    common_sso_jump: 'https://dlinesso.giant.com.cn/index.php/api/app_sso_login?token=',
    GIANT_CDN: 'https://giant-images.oss-cn-shanghai.aliyuncs.com/eshop/static',//捷安特CDN
  });
  store.commit('changeEnvironment', false);//正式环境
  store.commit('updateState', {
    label: 'siteUrl',
    data: 'https://e.giant.com.cn',
  });
}



//导出store
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js